<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { globalKeys } from '~/assets/data/global-keys';
import LazyImage from '../design-system/lazy-image.vue';
import type { IRestoreData } from '~/interfaces/dto/general/toast-messages';

const props = defineProps<{
  restoreData: IRestoreData;
}>();

const emit = defineEmits<{ (e: 'closeToast'): void }>();

const auth = useAuthStore();
const { $t, $trackEvent } = useNuxtApp();
const { $storageService } = useServices();

const confirmClicked = ref<boolean>(false);

async function handleRestore() {
  confirmClicked.value = true;
  if (!!props?.restoreData?.game) {
    $storageService.removeCookie({
      key: globalKeys.navigationKeys.lastRoute(auth?.userId),
    });
    $trackEvent('GameEvent', 'RESTORE_GAME', {
      game_name: props?.restoreData?.game?.alias,
      msisdn: auth?.currentUser?.username,
    });
  } else {
    $trackEvent('GameEvent', 'RESTORE_SESSION', {
      last_route: props?.restoreData?.restoreUrl,
      msisdn: auth?.currentUser?.username,
    });
  }
  emit('closeToast');
}

onMounted(() => {
  $storageService.setSessionStorage({
    key: globalKeys.navigationKeys.hasRestoredSession(
      auth?.userId ||
        $storageService.getCookie({ key: globalKeys.authKeys.userId }),
    ),
    data: true,
  });
});

onUnmounted(() => {
  if (!confirmClicked.value) {
    $storageService.removeCookie({
      key: globalKeys.navigationKeys.lastRoute(auth?.userId),
    });
    $storageService.removeCookie({
      key: globalKeys.navigationKeys.lastGame(auth?.userId),
    });
  }
});
</script>

<template>
  <div class="z-20">
    <div class="flex-center flex-col">
      <LazyImage
        v-if="!!props?.restoreData?.game"
        class="my-2 px-7 w-full h-full"
        :src="props?.restoreData?.game?.tileImage"
      />
      <div class="w-full p-2">
        <NuxtLink :to="props?.restoreData?.restoreUrl" @click="handleRestore()">
          <Button
            type="primary"
            class="w-full flex-center"
            padding="sm"
            rounded="md"
          >
            {{ $t('confirm') }}
          </Button>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
